import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@alfalab/core-components/button';
import { useMedia } from '@alfalab/hooks';
import { ClockMIcon } from '@alfalab/icons-glyph/ClockMIcon';
import { SystemMessage } from '../system-message';
/**
 * Пустое состояние больших блоков.
 *
 * [Макет](https://www.figma.com/file/OiFlIdSpmFYZ5zsFGWA3TD/Web-%3A%3A-Alfa-Online-Components?type=design&node-id=90259%3A452703&mode=design&t=SKy8iqvlgcEkBEvy-1)
 */
export const ContentState = ({ className, dataTestId, title, text, layout = 'm', Icon = ClockMIcon, buttonText, context, onButtonClick, }) => {
    const [mobile] = useMedia([[true, '(max-width: 1023px)']], false);
    const buttonSize = mobile ? 'm' : 's';
    if (layout === 's') {
        return (_jsx(SystemMessage, { view: 'compact', dataTestId: dataTestId, onClick: onButtonClick, className: className, compactTitle: text, compactButtonText: buttonText, Icon: Icon, compactIconBackgroundColor: Icon === ClockMIcon ? 'none' : '' }));
    }
    return (_jsxs(SystemMessage, { paddings: context === 'select' ? 40 : undefined, dataTestId: dataTestId, className: className, children: [_jsx(SystemMessage.Graphic, { Icon: Icon }), _jsx(SystemMessage.Title, { children: title }), _jsx(SystemMessage.Subtitle, { children: text }), buttonText && (_jsx(SystemMessage.Controls, { children: _jsx(Button, { onClick: onButtonClick, size: buttonSize, view: 'secondary', dataTestId: 'content-state-button', children: buttonText }) }))] }));
};
